export default {
  currency: (num: string | number | bigint | null) => {
    if (typeof num === 'string') {
      num = Number(num)
    }

    if ((typeof num === 'number' || typeof num === 'bigint') && !isNaN(Number(num))) {
      return (
        'Rp ' +
        new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(num))
      )
    }

    return 'Rp 0,00'
  },

  currencyNonRp: (num: string | number | bigint | null) => {
    if (typeof num === 'string') {
      num = Number(num)
    }

    if ((typeof num === 'number' || typeof num === 'bigint') && !isNaN(Number(num))) {
      return (
        new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(num))
      )
    }

    return '0,00'
  },

  currencyPrint: (num: string | number | bigint | null) => {
    if (typeof num === 'string') {
      num = Number(num)
    }

    if ((typeof num === 'number' || typeof num === 'bigint') && !isNaN(Number(num))) {
      return (
        new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(Number(num))
      )
    }

    return '0'
  },
}
